// New Relic Browser Monitoring Script
import { useEffect } from 'react';
import { logger } from "../utils/logger";
// import { logger } from "../utils/logger";
export const NewRelicScript = () => {
    useEffect(() => {
        // Skip New Relic loading to avoid DNS issues
        logger.debug('Skipping New Relic script to avoid DNS issues');
        return;
        // Check if New Relic is already loaded
        if (typeof window !== 'undefined' && (window as any).newrelic) {
            logger.debug('New Relic already loaded');
            return;
        }
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        // Test connectivity first
        const testConnection = async () => {
            try {
                const response = await fetch('https://js.newrelic.com/nr-1200.min.js', {
                    method: 'HEAD',
                    mode: 'no-cors',
                    cache: 'no-cache'
                });
                return true;
            }
            catch (error) {
                logger.error('New Relic script not accessible:', error, {});
                return false;
            }
        };
        // Load New Relic browser monitoring script with better error handling
        const loadNewRelicScript = async () => {
            const isAccessible = await testConnection();
            if (!isAccessible) {
                logger.warn('New Relic script not accessible, skipping load');
                return;
            }
            const script = document.createElement('script');
            script.src = 'https://js.newrelic.com/nr-1200.min.js';
            script.async = true;
            script.crossOrigin = 'anonymous';
            // Add timeout to prevent hanging
            const timeout = setTimeout(() => {
                if (!script.getAttribute('data-loaded')) {
                    logger.warn('New Relic script load timeout');
                    script.remove();
                }
            }, 5000); // 5 second timeout
            script.onload = () => {
                clearTimeout(timeout);
                script.setAttribute('data-loaded', 'true');
                logger.debug('New Relic script loaded successfully');
            };
            script.onerror = (error) => {
                clearTimeout(timeout);
                logger.error('Failed to load New Relic script:', error, {});
                script.remove();
            };
            document.head.appendChild(script);
        };
        // Use microtask for better performance instead of blocking setTimeout
        Promise.resolve().then(() => {
            if (window.requestIdleCallback) {
                window.requestIdleCallback(loadNewRelicScript, { timeout: 500 });
            }
            else {
                loadNewRelicScript();
            }
        });
        return () => {
            // Cleanup script on unmount
            const existingScript = document.querySelector('script[src="https://js.newrelic.com/nr-1200.min.js"]');
            if (existingScript) {
                existingScript.remove();
            }
        };
    }, []);
    return null;
};
export default NewRelicScript;
